import { render, staticRenderFns } from "./PlacementSidebar.vue?vue&type=template&id=37228d62"
import script from "./PlacementSidebar.vue?vue&type=script&lang=js"
export * from "./PlacementSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports